import moment from 'moment';

export const daysLeftInCycle = (cycleEndDate, today = moment()) => {
  const end = moment(cycleEndDate);
  const daysLeft = moment.duration(end.diff(today)).asDays();
  return Math.floor(daysLeft);
}

export const timeLeftInCycle = (cycleEndDate, today = moment()) => {
  const daysLeft = daysLeftInCycle(cycleEndDate, today);
  if (daysLeft > 0) {
    let unit = daysLeft === 1 ? 'day' : 'days';
    return [daysLeft, unit];
  }
  const end = moment(cycleEndDate);
  let hoursLeft = moment.duration(end.diff(today)).asHours();
  hoursLeft = Math.floor(hoursLeft);
  let unit = hoursLeft === 1 ? 'hour' : 'hours';

  return [hoursLeft, unit];
}
